var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _vm.user
      ? _c(
          "div",
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12, xs: 24 } },
                  [
                    _c(
                      "el-card",
                      [
                        _c(
                          "el-tabs",
                          {
                            model: {
                              value: _vm.activeTab,
                              callback: function ($$v) {
                                _vm.activeTab = $$v
                              },
                              expression: "activeTab",
                            },
                          },
                          [
                            _c(
                              "el-tab-pane",
                              { attrs: { label: "Account", name: "account" } },
                              [
                                _c(
                                  "ul",
                                  { staticStyle: { "padding-left": "17px" } },
                                  [
                                    _c("li", [
                                      _c("b", [_vm._v("User name:")]),
                                      _vm._v(" " + _vm._s(_vm.name) + " "),
                                    ]),
                                    _c("li", [
                                      _c("b", [_vm._v("User ID:")]),
                                      _vm._v(" " + _vm._s(_vm.username) + " "),
                                    ]),
                                  ]
                                ),
                                _c("account"),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }